// extracted by mini-css-extract-plugin
module.exports = {"main-component":"incrementArrow_main-component__BHm9Y"};